exports.translate_status = (status, vm) => {
  switch (status) {
    case "E":
      return vm.$t("emmited");
    case "F":
      return vm.$t("failed");
    case "R":
      return vm.$t("requesting");
    default:
      return `¿? [${status}]`;
  }
};